import { render } from "./Subscriptions.vue?vue&type=template&id=3ede0c10&scoped=true"
import script from "./Subscriptions.vue?vue&type=script&lang=js"
export * from "./Subscriptions.vue?vue&type=script&lang=js"

import "./Subscriptions.vue?vue&type=style&index=0&id=3ede0c10&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ede0c10"]])

export default __exports__